import { t as r, c } from "./format._HymmFPq.js";
function h(e) {
  const n = r(e), t = n.getFullYear(), s = n.getMonth(), o = c(e, 0);
  return o.setFullYear(t, s + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function M(e, n) {
  const t = r(e), s = t.getFullYear(), o = t.getDate(), a = c(e, 0);
  a.setFullYear(s, n, 15), a.setHours(0, 0, 0, 0);
  const u = h(a);
  return t.setMonth(n, Math.min(o, u)), t;
}
export {
  M as s
};
//# sourceMappingURL=setMonth.DkCYdG2x.js.map
